export enum CONDITION_TYPE {
  GENERAL_REQUIREMENT = 'GENERAL_REQUIREMENT',
  ENGLISH_REQUIREMENT = 'ENGLISH_REQUIREMENT',
  OTHER_TEST_REQUIREMENT = 'OTHER_TEST_REQUIREMENT',
  OTHERS_REQUIREMENT = 'OTHERS_REQUIREMENT',
  ADDITIONAL_REQUIREMENT = 'ADDITIONAL_REQUIREMENT',
}

export enum CHECK_TYPE {
  MEET = 'MEET',
  NOT_MEET = 'NOT_MEET',
}
